// Libs
import { Button, Flexbox } from '@ibinder/common-frontend';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ButtonsContainer = styled(Flexbox)`
  padding: 0.375rem 1rem;
  button {
    width: auto;
  }
`;

const CreateBinderModalFooter = ({
  onCancel,
  onCreate,
  onCreateText,
  ...others
}) => {
  const { t } = useTranslation();

  return (
    <ButtonsContainer {...others} justifyContent='space-between'>
      <Button
        btnStyle='secondary'
        btnExtras={['iconleft']}
        label={t('cancel')}
        onClick={onCancel}
      />
      <Button
        btnStyle='primary'
        btnExtras={['iconleft']}
        label={onCreateText}
        onClick={onCreate}
      />
    </ButtonsContainer>
  );
};

export default CreateBinderModalFooter;
